// extracted by mini-css-extract-plugin
export default {"typedFont":"typed_typedFont__U8I7Z"};